import { render, staticRenderFns } from "./ButtonCard.vue?vue&type=template&id=26be6c18&"
import script from "./ButtonCard.vue?vue&type=script&lang=js&"
export * from "./ButtonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports